import { render, staticRenderFns } from "./DetailTrailer.vue?vue&type=template&id=ff405454&scoped=true&"
import script from "./DetailTrailer.vue?vue&type=script&lang=js&"
export * from "./DetailTrailer.vue?vue&type=script&lang=js&"
import style0 from "./DetailTrailer.vue?vue&type=style&index=0&id=ff405454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff405454",
  null
  
)

export default component.exports